import a from"./builder.js";const t=({data:t,domain:r,pageId:d,pages:e={},path:i,route:o,trailingSlash:l})=>({breadcrumb:a(d,{data:t,domain:r,path:i,route:o,trailingSlash:l},e)});export{t as default};
